import { OptionProps } from '@welbe/web-design-system/lib/components/molecules/InputSelect/InputSelect.types';
import { AxiosResponse } from 'axios';
import { api as companiesApi } from 'services/companiesApi';

export const postApproveCandidate = async (
	candidateId: string,
	payload: {
		branchOfficeId: string;
		businessName: OptionProps;
		insuranceId: string;
		companyBadgeNumber: string | undefined;
		hiringDate: string | undefined;
		sector: string | undefined;
		shift: string | undefined;
		position: string | undefined;
	},
): Promise<AxiosResponse> => {
	return await companiesApi.post(`/candidates/${candidateId}/approve`, payload);
};

export const getCompanyBusinessNames = async (): Promise<AxiosResponse> =>
	await companiesApi.get('/candidates/company-business-names');
